import React, { useCallback, useState } from 'react'
import validator from 'validator'
import { useParams } from 'react-router-dom'

import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import { makeStyles } from '@material-ui/core/styles'

import { useDialog } from '../hooks/useDialog'

import TeamContainer from './TeamContainer'
import { headerImage } from './constants/selection_process'

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(4),
    },
  },
  card: {
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
    },
  },
  cardHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    position: 'relative',
  },
  registrationLogoImage: {
    width: '100%',
  },
})
const useStyles = makeStyles(styles)

export default function TeamRoute() {
  const { team } = useParams()

  const teamNumber = Number(String(team).replace(/\D/g, ''))

  const [authorizationToken, setAuthorizationToken] = useState('OPEN')

  const [passwordValue, setPasswordValue] = useState('')
  const [passwordValueError, setPasswordValueError] = useState(false)
  const passwordDialog = useDialog(!authorizationToken)
  const handleClose = useCallback(() => {
    if (passwordValue && !validator.isEmpty(passwordValue)) {
      setAuthorizationToken(passwordValue)
      setPasswordValueError(false)
      passwordDialog.close()
    } else {
      setPasswordValueError(true)
    }
  }, [
    passwordDialog,
    passwordValue,
    setAuthorizationToken,
    setPasswordValueError,
  ])

  const invalidateAuthorizationToken = useCallback(() => {
    setAuthorizationToken(null)
    setPasswordValueError(true)
    passwordDialog.open()
  }, [passwordDialog, setAuthorizationToken, setPasswordValueError])

  const classes = useStyles()

  return (
    <Grid className={classes.root} container>
      <Grid item xs={12}>
        <Grid container justify="center">
          <Grid item md={10} lg={9} xl={8}>
            <Card className={classes.card}>
              <div className={classes.cardHeader}>
                <img
                  alt="logo"
                  className={classes.registrationLogoImage}
                  src={headerImage}
                />
              </div>
            </Card>

            <Dialog
              disableBackdropClick
              disableEscapeKeyDown
              onClose={passwordDialog.close}
              open={passwordDialog.isOpen}
            >
              <DialogTitle>Senha de Acesso</DialogTitle>

              <DialogContent>
                <DialogContentText>
                  Por favor informe a senha de acesso.
                </DialogContentText>

                <TextField
                  fullWidth
                  error={passwordValueError}
                  label="Senha"
                  margin="dense"
                  onChange={(event) => setPasswordValue(event.target.value)}
                  type="text"
                />
              </DialogContent>

              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  OK
                </Button>
              </DialogActions>
            </Dialog>

            {!!authorizationToken && (
              <TeamContainer
                authorizationToken={authorizationToken}
                invalidateAuthorizationToken={invalidateAuthorizationToken}
                teamNumber={teamNumber}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
